module.exports = __webpack_public_path__ + "img/indu_active_17.88b93f4a.png";